import { render, staticRenderFns } from "./TeamFormNoAccount.vue?vue&type=template&id=18d9d916&scoped=true&"
import script from "./TeamFormNoAccount.vue?vue&type=script&lang=js&"
export * from "./TeamFormNoAccount.vue?vue&type=script&lang=js&"
import style0 from "./TeamFormNoAccount.vue?vue&type=style&index=0&id=18d9d916&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d9d916",
  null
  
)

export default component.exports